import React from "react";

const SocialIcons = ({ type }) => {
	const icons =
		type == "support"
			? [
					"/assets/support/Facebook.svg",
					"/assets/support/Instagram.svg",
					"/assets/support/X.svg",
					"/assets/support/TikTok.svg",
					"/assets/support/YouTube.svg",
					"/assets/support/LinkedIn.svg",
					"/assets/support/Reddit.svg",
				]
			: [
					"/assets/home/footer/Facebook.png",
					"/assets/home/footer/Instagram.png",
					"/assets/home/footer/X.png",
					"/assets/home/footer/TikTok.png",
					"/assets/home/footer/YouTube.png",
					"/assets/home/footer/LinkedIn.png",
					"/assets/home/footer/Reddit.png",
				];
	return (
		<>
			{icons.map((icon, i) => (
				<img
					loading="lazy"
					decoding="async"
					key={i}
					src={icon}
					alt={`icon-${i}`}
					className="w-[18px] h-[18px]"
				/>
			))}
		</>
	);
};

export default SocialIcons;
